// extracted by mini-css-extract-plugin
module.exports = {"LdsRoller":"LoaderSection_LdsRoller__Kt_fq","lds-roller":"LoaderSection_lds-roller__YDo42"};